import type {
  CartAddRequest,
  CartAddResponse,
  CartRemoveRequest,
  CartRemoveResponse,
  CartTotalRequest,
  CartTotalResponse,
  CartTransferRequest,
  CartTransferResponse,
} from "@features/shopping/types";

import { api } from "@services/api";
import { decryptData, encryptData } from "@shared/utils/encryption";

export class CartService {
  private readonly basePath = "/public/cart";

  // Add Cart
  public async addCart(data: CartAddRequest): Promise<CartAddResponse> {
    const response = await api.post<{ data: string }>(`${this.basePath}/add`, {
      data: await encryptData(data),
    });

    return await decryptData(response.data);
  }

  // Remove Cart
  public async removeCart(data: CartRemoveRequest): Promise<CartRemoveResponse> {
    const response = await api.post<{ data: string }>(`${this.basePath}/remove`, {
      data: await encryptData(data),
    });

    return await decryptData(response.data);
  }

  // Total Cart
  public async totalCart(data: CartTotalRequest): Promise<CartTotalResponse> {
    const response = await api.post<{ data: string }>(`${this.basePath}/total`, {
      data: await encryptData(data),
    });

    return await decryptData(response.data);
  }

  // Transfer Cart
  public async transferCart(data: CartTransferRequest): Promise<CartTransferResponse> {
    const response = await api.post<{ data: string }>(`${this.basePath}/transfer/member`, {
      data: await encryptData(data),
    });

    return await decryptData(response.data);
  }
}

export const cartService = new CartService();
